module.exports = __webpack_public_path__ + "img/each-panel-icon.f01b779b.svg";